import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Briefcase, Building2, Star, ArrowRight } from 'lucide-react';
import { useLocale } from '../i18n/LocaleProvider';
import { pick, employmentTypeLabel, remotePolicyLabel } from '../i18n/pick';
import Chip from './Chip';

export default function JobCard({ job }) {
  const { locale, t } = useLocale();

  const title = pick(job, locale, 'title');
  const teaser = pick(job, locale, 'teaser');
  const location = pick(job, locale, 'location');
  const empType = employmentTypeLabel(job.employment_type, locale);
  const remote = remotePolicyLabel(job.remote_policy, locale);

  return (
    <Link
      to={`/${job.slug}`}
      className="group relative flex flex-col rounded-xl border border-sand bg-cream p-5 shadow-card transition-all hover:-translate-y-0.5 hover:border-gold/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold"
    >
      {job.is_featured && (
        <span className="absolute right-4 top-4 inline-flex items-center gap-1 font-num text-[10px] uppercase tracking-wider text-gold">
          <Star className="h-3 w-3 fill-gold" /> {locale === 'fr' ? 'En vedette' : locale === 'nl' ? 'Uitgelicht' : 'Featured'}
        </span>
      )}

      <h3 className="pr-16 font-display text-xl font-semibold leading-snug text-greenDeep">
        {title}
      </h3>

      {teaser && (
        <p className="mt-2 line-clamp-3 text-[0.95rem] text-ink/80">{teaser}</p>
      )}

      <div className="mt-4 flex flex-wrap gap-1.5">
        <Chip icon={MapPin}>{location}</Chip>
        <Chip icon={Briefcase}>{empType}</Chip>
        {remote && <Chip icon={Building2}>{remote}</Chip>}
      </div>

      <span className="mt-4 inline-flex items-center gap-1.5 font-num text-xs font-medium uppercase tracking-wider text-greenDeep/70 transition-colors group-hover:text-gold">
        {t.viewOffer}
        <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
      </span>
    </Link>
  );
}
